import React from 'react';
import './getStartedGlobal.scss';
import {Button} from "../button/Button";
import {useNavigate} from "react-router-dom";

const GetStartedGlobal = () => {
    const navigate = useNavigate();
    return (
        <div className={'get-started-global'}>
            <div className="get-started-global_wrapper max">
                <div className="get-started-global_wrapper_float">
                    <div className="get-started-global_wrapper_float_01"/>
                    <div className="get-started-global_wrapper_float_02"/>
                </div>
                <div className="get-started-global_wrapper_left">
                    <h1>Get Started With Us Today</h1>
                    <p id={'text'}>Join us and gain access to all the amazing benefits that comes with being a
                        member. </p>
                </div>
                <div className="get-started-global_wrapper_right">
                    <Button text={'Join Us'} type={'primary'} onclick={() => navigate('/registration/')}/>
                    <Button text={'Learn More'} type={'tertiary'} onclick={() => navigate('/about')}/>
                </div>
            </div>
        </div>
    );
};

export default GetStartedGlobal;
